import React, { PureComponent } from 'react'
import { bool, string } from 'prop-types'
import { ImageAndText } from 'components'
import carImage from 'assets/images/car.svg'
import './SectionIntro.css'

export class SectionIntro extends PureComponent {
    static propTypes = {
        show: bool.isRequired,
        text: string.isRequired
    }
    static defaultProps = {
        show: true
    }

    render() {
        const { show, text } = this.props
        return (
            <section className={['Intro', { Show: show }]}>
                <ImageAndText
                    image={{ src: carImage, style: { width: '300px' } }}
                    text={text}
                />
            </section>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Sections/Intro/SectionIntro.js